import Fields from './RegistrationOptionFields.json';

export default {
  [Fields.lastName.id]: {
    id: Fields.lastName.id,
    regApiPath: ['lastName'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 50,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true,
    alwaysEnforceRequiredValidation: true,
    plannerRegistrationReadOnly: true
  },
  [Fields.prefix.id]: {
    id: Fields.prefix.id,
    regApiPath: ['prefix'],
    searchAttendeeKey: 'salutation',
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.profileImage.id]: {
    id: Fields.profileImage.id,
    regApiPath: ['profileImage'],
    searchAttendeeKey: null,
    limitFileFormats: true,
    questionTypeInfo: {
      questionType: 'FileUpload',
      allowedFileFormats: ['jpg', 'gif', 'png', 'jpeg']
    },
    availableForGuests: false
  },
  [Fields.company.id]: {
    id: Fields.company.id,
    regApiPath: ['company'],
    searchAttendeeKey: 'company',
    questionTypeInfo: {
      max: 100,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.emailAddress.id]: {
    id: Fields.emailAddress.id,
    regApiPath: ['emailAddress'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 80,
      answerFormatType: 'EmailAddress',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true,
    plannerRegistrationReadOnly: true
  },
  [Fields.homePhone.id]: {
    id: Fields.homePhone.id,
    regApiPath: ['homePhone'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.homeAddress.id]: {
    id: Fields.homeAddress.id,
    regApiPath: ['homeAddress'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      questionType: 'Address'
    },
    availableForGuests: true
  },
  [Fields.pager.id]: {
    id: Fields.pager.id,
    regApiPath: ['pager'],
    searchAttendeeKey: 'pager',
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: false
  },
  [Fields.designation.id]: {
    id: Fields.designation.id,
    regApiPath: ['designation'],
    searchAttendeeKey: 'designation',
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.middleName.id]: {
    id: Fields.middleName.id,
    regApiPath: ['middleName'],
    searchAttendeeKey: 'middleName',
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.firstName.id]: {
    id: Fields.firstName.id,
    regApiPath: ['firstName'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true,
    alwaysEnforceRequiredValidation: true,
    plannerRegistrationReadOnly: true
  },
  [Fields.sourceId.id]: {
    id: Fields.sourceId.id,
    regApiPath: ['sourceId'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: false,
    plannerRegistrationReadOnly: true,
    knownInviteeReadOnly: true
  },
  [Fields.workFax.id]: {
    id: Fields.workFax.id,
    regApiPath: ['workFax'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: false
  },
  [Fields.passportCountry.id]: {
    id: Fields.passportCountry.id,
    regApiPath: ['passportCountryCode'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      displayType: 'DropDown',
      choices: [],
      questionType: 'SingleChoice'
    },
    availableForGuests: true
  },
  [Fields.twitterUrl.id]: {
    id: Fields.twitterUrl.id,
    regApiPath: ['socialMediaUrls', 'TWITTER'],
    searchAttendeeKey: 'twitterLink',
    questionTypeInfo: {
      max: 2500,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: false
  },
  [Fields.mobile.id]: {
    id: Fields.mobile.id,
    regApiPath: ['mobilePhone'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.facebookUrl.id]: {
    id: Fields.facebookUrl.id,
    regApiPath: ['socialMediaUrls', 'FACEBOOK'],
    searchAttendeeKey: 'facebookLink',
    questionTypeInfo: {
      max: 2500,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: false
  },
  [Fields.workPhone.id]: {
    id: Fields.workPhone.id,
    regApiPath: ['workPhone'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: false
  },
  [Fields.linkedInUrl.id]: {
    id: Fields.linkedInUrl.id,
    regApiPath: ['socialMediaUrls', 'LINKEDIN'],
    searchAttendeeKey: 'linkedinLink',
    questionTypeInfo: {
      max: 2500,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: false
  },
  [Fields.homeFax.id]: {
    id: Fields.homeFax.id,
    regApiPath: ['homeFax'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: false
  },
  [Fields.ccEmailAddress.id]: {
    id: Fields.ccEmailAddress.id,
    regApiPath: ['ccEmailAddress'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 80,
      answerFormatType: 'EmailAddress',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.title.id]: {
    id: Fields.title.id,
    regApiPath: ['title'],
    searchAttendeeKey: 'title',
    questionTypeInfo: {
      max: 100,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.workAddress.id]: {
    id: Fields.workAddress.id,
    regApiPath: ['workAddress'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      questionType: 'Address'
    },
    availableForGuests: false
  },
  [Fields.dateOfBirth.id]: {
    id: Fields.dateOfBirth.id,
    regApiPath: ['dateOfBirth'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      minDate: '1900-01-01T00:00:00',
      displayFormatTypeId: 'DateOnlyMonthFirst',
      questionType: 'OpenEndedDateTime'
    },
    availableForGuests: true
  },

  [Fields.gender.id]: {
    id: Fields.gender.id,
    regApiPath: ['gender'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      displayType: 'DropDown',
      choices: [
        {
          id: 'MALE',
          text: '_fieldOption_male__resx'
        },
        {
          id: 'FEMALE',
          text: '_fieldOption_female__resx'
        },
        {
          id: 'NON_BINARY',
          text: '_fieldOption_nonBinary__resx'
        },
        {
          id: 'PREFER_NOT_TO_ANSWER',
          text: '_fieldOption_preferNotToAnswer__resx'
        }
      ],
      questionType: 'SingleChoice'
    },
    availableForGuests: true
  },
  [Fields.nickname.id]: {
    id: Fields.nickname.id,
    regApiPath: ['nickname'],
    searchAttendeeKey: 'nickname',
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.passportNumber.id]: {
    id: Fields.passportNumber.id,
    regApiPath: ['passportNumber'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'SecureText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.ssn.id]: {
    id: Fields.ssn.id,
    regApiPath: ['socialSecurityNumber'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 11,
      answerFormatType: 'SocialSecurityNumber',
      questionType: 'SecureText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.nin.id]: {
    id: Fields.nin.id,
    regApiPath: ['nationalIdentificationNumber'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 30,
      answerFormatType: 'General',
      questionType: 'SecureText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  },
  [Fields.nationalProviderIdentifier.id]: {
    id: Fields.nationalProviderIdentifier.id,
    regApiPath: ['nationalProviderIdentifier'],
    searchAttendeeKey: null,
    questionTypeInfo: {
      max: 10,
      answerFormatType: 'NationalProviderIdentifier',
      questionType: 'OpenEndedText',
      openEndedType: 'OneLine'
    },
    availableForGuests: true
  }
};
